import React from 'react';
import Money from '../Common/Money/Money';
import InfoIcon from '../icons/InfoIcon';
import styles from './ticketCard.module.css';
import ProductCheck from './ProductCheck';
import { useTranslation } from 'react-i18next';

const ProductCard = ({
  product,
  handleIncrement,
  handleDecrement,
  onInfoClick,
  isExtraPax,
  onlyOne = false,
  hasMoreInfo = false,
  mainPax = 1,
  centerName = false,
  selectedOpenBarHours = 0,
}) => {
  const { t } = useTranslation();
  const maxAvailable = isExtraPax ? product.extraPax : product.stock;
  const isSoldOut = product.hasSoldOut || (maxAvailable && maxAvailable <= 0);

  const onCheckClick = (e) => {
    if (e) handleIncrement();
    else handleDecrement();
  };

  const renderPrice = () => {
    let price = product.prices.price;
    if (isExtraPax) {
      price = product.prices.priceExtraPax;
    } else if (product.specialType === 'PER_HOUR_ALL_PAX') {
      price = product.prices.price * mainPax;
    } else if (product.specialType === 'OPEN_BAR_HOURS' && selectedOpenBarHours > 0) {
      price = product.prices.price * selectedOpenBarHours;
    }
    return <Money value={price} decimal={false} />;
  };

  const renderButtons = () => {
    return (
      <div className='col-auto pl-0'>
        <div className={styles.quantityContainer}>
          {product.quantity > 0 && (
            <button className={styles.subtract} onClick={handleDecrement}>
              -
            </button>
          )}
          <button className={styles.add} onClick={handleIncrement}>
            +
          </button>
        </div>
      </div>
    );
  };

  const renderCheck = (isChecked) => {
    return (
      <div className='col-auto pl-0'>
        <div className={styles.quantityCheckbox}>
          <ProductCheck onCheck={(e) => onCheckClick(e)} isChecked={isChecked} />
        </div>
      </div>
    );
  };

  const renderSubtitle = () => {
    if (isExtraPax) return product.name;
    switch (product.specialType) {
      case 'KIDS':
        return t('pricePerKid');
      case 'PER_HOUR_ALL_PAX':
        if (Number(mainPax) === 1) {
          return t('pricePerHourSingle', { count: Number(mainPax) });
        } else {
          return t('pricePerHourMultiple', { count: Number(mainPax) });
        }
      case 'UNIQUEEXTRAPRODUCT':
      case 'EXTRAPRODUCT':
        return t('pricePerUnit');
      case 'UNIQUE_EXTRA_PRODUCT':
        return t('finalPrice');
      case 'EXTRA_PRODUCT':
        return t('pricePerUnit');
      case 'OPEN_BAR_HOURS':
        return t('pricePerPaxMultiple', { count: Number(selectedOpenBarHours) });
      case 'NUMBER_OF_HOURS':
        return t('');

      default:
        if (product.reservationType === 'AREA')
          return (
            <>
              {t('upToGuests', { pax: product.pax })}
              {product.extraPax && product.extraPax > 0 ? (
                <span>
                  {' '}
                  + {product.extraPax} {t('extraGuests')} ($)
                </span>
              ) : null}
            </>
          );
        else return t('pricePerPerson');
    }
  };

  return (
    <div
      className={`${isSoldOut ? styles.soldOut : ''} ${
        product.disabled ? styles.disabled : ''
      } mb-2`}
    >
      <div className='row'>
        <div className={`col ${isSoldOut ? '' : 'pr-0'}`}>
          <div className={styles.container}>
            <div className='row m-0' style={{ minHeight: '86px' }}>
              {product.images &&
              product.images.length > 0 &&
              product.specialType !== 'PER_HOUR_ALL_PAX' ? (
                <div className='col-auto my-auto  pl-2 pr-0'>
                  <div className='position-relative'>
                    <img
                      src={product.images[0]}
                      title={product.name}
                      className={styles.productImage}
                    />
                    {product.locationCode && (
                      <div
                        className={styles.productCode}
                        style={{ backgroundColor: product.hexColor }}
                      >
                        {product.locationCode}
                      </div>
                    )}
                  </div>
                </div>
              ) : null}

              <div className={`col text-truncate my-auto px-2`}>
                <div
                  className={`fw-semibold text-truncate ${styles.productName}`}
                  style={centerName ? { display: 'flex', alignItems: 'center' } : {}}
                >
                  {isExtraPax ? t('extraGuest') : product.name}
                  {hasMoreInfo ? (
                    <span className={styles.productInfoIcon} onClick={onInfoClick}>
                      <InfoIcon size='13px' styles={{ marginTop: '-3px' }} />
                    </span>
                  ) : null}
                </div>

                <div
                  className={`${styles.productSubTitle} font-small text-truncate light`}
                  style={{ lineHeight: '1.1' }}
                >
                  {renderSubtitle()}
                </div>
                <div className={centerName === false ? styles.productPrice : ''}>
                  <span className='fw-semibold'>{renderPrice()}</span>
                </div>
              </div>

              {isSoldOut ? (
                <div className='col-auto my-auto'>
                  <div className={styles.soldOutLabel}>{t('soldOut')}</div>
                </div>
              ) : null}

              {product.quantity > 0 && !onlyOne && (
                <div className={`col-auto ${styles.quantity} pl-0 pr-2 my-auto`}>
                  {product.quantity}
                  {product.specialType === 'PER_HOUR_ALL_PAX' && (
                    <span className='font-1rem  ml-1 text-secondary'>(hrs)</span>
                  )}
                </div>
              )}
            </div>
            {hasMoreInfo && (
              <div className={styles.moreInfo} onClick={onInfoClick}>
                {t('moreInfo')}
              </div>
            )}
          </div>
        </div>
        {!isSoldOut ? (onlyOne ? renderCheck(product.quantity > 0) : renderButtons()) : null}
      </div>
    </div>
  );
};

export default ProductCard;
